
'use strict';

const uploadPDFSelector = '.js-edit-sale-pdf',
    removePDFSelector = '.js-remove-sale-pdf',
    forSaleSelector = '#js-ForSaleDetails',
    pdfDescSelector = '#js-edit-sale-pdf-desc',
    pdfIDSelector = '#js-edit-sale-pdf-id',
    horseIDSelector = '#horse_id',
    photosSelector = '.js-edit-sale-photos';

export function isInt(value) {
    if (isNaN(value)) {
        return false;
    }
    var x = parseFloat(value);
    return (x || 0) === x;
}

export function PedigreePDFUploaded(uploader, file, response) {
    var data = jQuery.parseJSON(response.response);
    $(pdfDescSelector).text(data.DESCRIPTION);
    $(pdfIDSelector).val(data.ATTACHMENT_ID);
    popWinClose();
}

export function getYouTubeGetID(url) {
    var ID = '';

    url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
    } else {
        ID = url;
    }
    return ID;
}

export function getVimeoGetID(url) {
    var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/,
        match = url.match(regExp);

    if (match) {
        return match[5];
    }
    return url;
}

export function bindYouTubeIDChanged() {
    $('#js-publicYouTubeID').bind('keyup keypress blur change', function () {
        var startingValue = $(this).val(),
            youTubeID = getYouTubeGetID(startingValue);
        $('#js-publicYouTubeID').val(youTubeID);
    });
}

export function bindPhotosClicked() {
    $(photosSelector).click(() => {
        viewImages($(horseIDSelector).val());
    });
}

export function bindVimeoIDChanged() {
    $('#js-publicVimeoID').bind('keyup keypress blur change', function () {
        var startingValue = $(this).val(),
            vimeoID = getVimeoGetID(startingValue);
        $('#js-publicVimeoID').val(vimeoID);
    });
}

export function bindUploadPdf() {
    $(uploadPDFSelector).bind('click', (event) => {
        event.preventDefault();

        var popURL,
            horseID = $(horseIDSelector).val();

        if (!(isInt(horseID) && horseID >= 0)) {
            alert('Please select the horse record before adding a Pedigree PDF');
            return;
        }

        popURL = '/pages/upload/pdf.cfm?' + jQuery.param({
            callback: 'horseForSale',
            horseID: horseID,
            uploadType: 'pdf',
        });

        popWin({
            title: 'Upload Pedigree',
            noAutoWidth: true,
            width: 395,
            height: 270,
            page: popURL,
            modal: true,
        });

    });
}

export function bindRemovePdf() {
    $(removePDFSelector).bind('click', (event) => {
        event.preventDefault();

        var htmlcontent = '<div class="confirmationPopup">';
        htmlcontent += '<div class="genericPopup">';
        htmlcontent += '<img class="infomationPopupImage" src="img/info.svg">';
        htmlcontent += "<div class='informationText warning'>";
        htmlcontent += '<p>This will remove the Pedigree PDF<br>from this Sale Horse.</p>';
        htmlcontent += '</div>';
        htmlcontent += '</div>';
        htmlcontent += "<div class='actionButtonsContainer'>";
        htmlcontent += '<a class="js-pop-confirm-ok jq_button">Remove</a>',
        htmlcontent += '<a class="js-pop-confirm-cancel jq_button">Cancel</a>';
        htmlcontent += '</div>';
        htmlcontent += '</div>';

        popWin({
            popID: 'pdfRemoveConfirmation',
            title: 'Confirm Remove PDF',
            classes: 'genericCardPop',
            noAutoWidth: false,
            modal: true,
            zIndex: 5000,
            contents: htmlcontent,
            hideCloseButton: false,
            loadComplete: function () {
                $('.jq_button').button();
                $('#pdfRemoveConfirmation')
                    .find('.js-pop-confirm-ok')
                    .bind('click', (event) => {
                        event.preventDefault();
                        $(pdfDescSelector).text('');
                        $(pdfIDSelector).val('');
                        popWinClose('pdfRemoveConfirmation');
                    });
                $('#pdfRemoveConfirmation')
                    .find('.js-pop-confirm-cancel')
                    .bind('click', (event) => {
                        event.preventDefault();
                        popWinClose('pdfRemoveConfirmation');
                    });
            },
        });

    });
}

export function displayEnableAPIPopup() {
    var htmlcontent = '<div class="confirmationPopup">';
    htmlcontent += '<div class="genericPopup">';
    htmlcontent += '<img class="infomationPopupImage" src="img/info.svg">';
    htmlcontent += '<div class="informationText warning">';
    htmlcontent += '<p>Please read our wiki for full details:';
    htmlcontent += '<a href="https://wiki.equisoftlive.com"';
    htmlcontent += 'target="_blank">https://wiki.equisoftlive.com</a></p>';
    htmlcontent += '</div>';
    htmlcontent += '</div>';
    htmlcontent += '<div class="actionButtonsContainer">';
    htmlcontent += '<a class="js-papi-confirm-ok jq_button">Enable Feature</a>';
    htmlcontent += '<a class="js-papi-confirm-cancel jq_button">Cancel</a>';
    htmlcontent += '</div>';
    htmlcontent += '</div>';

    popWin({
        popID: 'papiConfirmPopup',
        title: 'Enable Feature Confirmation',
        classes: 'genericCardPop',
        noAutoWidth: false,
        modal: true,
        zIndex: 5000,
        contents: htmlcontent,
        hideCloseButton: false,
        loadComplete: function () {
            $('.jq_button').button();
            $('#papiConfirmPopup').find('.js-papi-confirm-ok').bind('click', (event) => {
                event.preventDefault();

                var updateURL = '/components/AcqDisp.cfc?' + jQuery.param({
                    method: 'enableAPIForSales',
                });

                $.ajax({
                    url: updateURL,
                    dataType: 'json',
                    success: function (data) {
                        if (data.SUCCESS) {
                            $('#js-listOnForSaleWebpage').attr('checked', 'checked');
                            popWinClose('papiConfirmPopup');
                            var $forSaleDetailsContainer = $(forSaleSelector);
                            $forSaleDetailsContainer.customShow();
                        } else {
                            alert('Failed to update setting. Please try again.');
                        }
                    },
                    error: function () {
                        alert('Failed to connect for update. Please try again.');
                    },
                });

            });

            $('#papiConfirmPopup')
                .find('.js-papi-confirm-cancel')
                .bind('click', (event) => {
                    event.preventDefault();
                    popWinClose('papiConfirmPopup');
                });

        },
    });
}

export function bindForSaleItems() {
    // Check if API Status and prompt to enable if needed
    var promptAPIEnable,
        $forSaleDetailsContainer;

    // Show hide For sale details bind
    $forSaleDetailsContainer = $(forSaleSelector);
    $('#js-listOnForSaleWebpage').bind('click', function (event) {
        promptAPIEnable = ($('#js-prompt-papi-enable').val() === '1');

        if (!$(this).attr('checked')) {
            promptAPIEnable = false; // only prompt when enabling item
        }

        if (promptAPIEnable) {
            event.preventDefault();
            displayEnableAPIPopup();
        } else {
            if ($(this).attr('checked')) {
                $forSaleDetailsContainer.customShow();
            } else {
                $forSaleDetailsContainer.customHide();
            }
        }
    });

    // Upload Pedigree PDF Bind
    bindUploadPdf();
    bindRemovePdf();
    bindYouTubeIDChanged();
    bindVimeoIDChanged();
    bindPhotosClicked();
}

export function showEditValuationPopup(options) {

    if (!options){
        options = {};
    }

    var popupTitle = '';

    if (!options.valuationID) {
        options.valuationID = 0;
    }

    if (options.valuationID !== 0) {
        // Existing Record
        options.horseID = '';
        popupTitle = $.i18n('EDIT_VALUATION');
    } else {
        // New Record
        if (!options.horseID) {
            const errorMsg = 'Unable to continue as horse ID not specified for new record.';
            errorMsg += 'Please try again.';
            alert(errorMsg);
            return;
        }
        popupTitle = $.i18n('ADD_VALUATION');
    }

    var popURL = '/pages/pop/?' + jQuery.param({
        module: 'horse',
        page: 'valuation_edit',
        horseID: options.horseID,
        valuationID: options.valuationID,
    });

    popWin({
        title: popupTitle,
        noAutoWidth: true,
        popID: 'horseEditValuation',
        width: 550,
        modal: true,
        page: popURL,
        buttons: {
            'Save': function () {
                $('#form_edit_valuation').submit();
            },
            'Close': function () {
                $(this).dialog('close');
            },
        },
    });
}

export function showDeleteValuationPopup(options){
    if (!options) {
        options = {};
    }

    if (!options.valuationID) {
        options.valuationID = 0;
    }

    if (!options.valuationID){
        alert('Unable to continue as Valuation ID not specified for record. Please try again.');
        return;
    }

    var popURL = '/pages/pop/?' + jQuery.param({
        module: 'horse',
        page: 'valuation_delete',
        valuationID: options.valuationID,
    });

    popWin({
        title: $.i18n('DELETE_VALUATION'),
        noAutoWidth: true,
        popID: 'horseDeleteValuation',
        width: 550,
        modal: true,
        page: popURL,
        buttons: {
            'Delete': function () {
                $('#form_delete_valuation').submit();
            },
            'Cancel': function () {
                $(this).dialog('close');
            },
        },
    });
}

export function init(options) {
    if (!options) {
        options = {};
    }
    $('.jq_button').button();
}